import type { Ref } from 'vue'
import type { TabKey } from '@/components/base/BaseTab.vue'

export type CustomerDetailTopTab = 'profile' | 'orders'
export type CustomerDetailMobileTab = 'informations' | 'activities'

export default function useCustomerDetailTabs(canSeeOrders: Ref<boolean | null>) {
  const { t } = useI18n()
  const route = useRoute()

  const requestedTab = route?.query?.activeTab as string | undefined

  const topTab = ref<CustomerDetailTopTab>(requestedTab === 'orders' ? 'orders' : 'profile')
  const currentTab = ref<CustomerDetailMobileTab>(requestedTab === 'activities' ? 'activities' : 'informations')

  watch(
    canSeeOrders,
    (canSee) => {
      if (canSee === false && topTab.value === 'orders') {
        topTab.value = 'profile'
      }
    },
    { immediate: true }
  )

  const topTabs = computed<TabKey[]>(() => [
    {
      value: 'profile',
      name: t('pages.customer.customerDetailPage.tabs.profile')
    },
    {
      value: 'orders',
      name: t('pages.customer.customerDetailPage.tabs.orders')
    }
  ])

  const tabs = computed<TabKey[]>(() => [
    {
      value: 'informations',
      name: t('pages.customer.customerDetailPage.tabs.informations')
    },
    {
      value: 'activities',
      name: t('pages.customer.customerDetailPage.tabs.activities')
    }
  ])

  return {
    topTab,
    topTabs,
    currentTab,
    tabs
  }
}
